export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";